import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import { FiscalYearSelect } from './FiscalYearSelect'
import { RankBy } from './RankBy'
import { TOP_COMPANY } from './constant'
import classes from './index.module.scss'
import { changeTopCompany, selectTopCompany } from './store/slice'

export const RightHeader = () => {
  const dispatch = useDispatch()

  const topCompany = useSelector(selectTopCompany)

  const chooseTopCompanyItem = (item) => {
    dispatch(changeTopCompany(item))
  }

  return (
    <div className={classes.container}>
      <Element
        className={classes.item}
        style={{ borderRight: '1px solid #9c9c9c' }}
      >
        <SelectCustom
          isBorderNone
          className="fw600"
          data={Object.values(TOP_COMPANY)}
          activeItem={topCompany}
          chooseItem={chooseTopCompanyItem}
        />
      </Element>
      <Element
        className={classes.item}
        style={{ borderRight: '1px solid #9c9c9c' }}
      >
        <Translate value="industryOverview.topIndustryPlayers.FY" />
        <FiscalYearSelect />
      </Element>
      <RankBy />
    </div>
  )
}
